import Fetch from "./Fetch";

import { API_BASIC_URL_SLOT_SERVICE } from "../config/constants";
import { handleError, handleResponse } from "./ApiUtils";

export const getCollectionPointsTypes = () => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/collectionpoints`).then(handleResponse).catch(handleError);
};

export const fetchServicePropositionRecord = () => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v2/services`).then(handleResponse).catch(handleError);
};
